var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.045,
    height: 24.24,
    viewBox: "0 0 19.045 24.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-trash",
    transform: "translate(-22.5 -14.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(22.5 14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M40.737,32.33,40.1,47.57a.591.591,0,0,1-.578.552H28.443a.592.592,0,0,1-.578-.552l-.635-15.24a.866.866,0,1,0-1.73.072l.635,15.24a2.323,2.323,0,0,0,2.308,2.211H39.524a2.322,2.322,0,0,0,2.308-2.211l.635-15.24a.866.866,0,1,0-1.73-.072Z",
    transform: "translate(-24.461 -25.613)",
    fill: "#d00000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M48,36.693V48.466a.693.693,0,0,0,1.385,0V36.693a.693.693,0,0,0-1.385,0Z",
    transform: "translate(-39.17 -28.555)",
    fill: "#d00000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M37,36.713l.346,11.773a.693.693,0,0,0,1.385-.041l-.346-11.773A.693.693,0,1,0,37,36.713Z",
    transform: "translate(-31.979 -28.555)",
    fill: "#d00000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M58.347,36.672,58,48.446a.693.693,0,1,0,1.385.041l.346-11.773a.693.693,0,0,0-1.385-.041Z",
    transform: "translate(-45.707 -28.555)",
    fill: "#d00000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M23.366,24.731H40.68a.866.866,0,1,0,0-1.731H23.366a.866.866,0,0,0,0,1.731Z",
    transform: "translate(-22.5 -20.057)",
    fill: "#d00000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M39.261,18.027l.36-1.262a.839.839,0,0,1,.709-.534h3.122a.839.839,0,0,1,.709.534l.36,1.262,1.665-.476-.36-1.262a2.558,2.558,0,0,0-2.374-1.79H40.33a2.558,2.558,0,0,0-2.374,1.79l-.36,1.262Z",
    transform: "translate(-32.369 -14.5)",
    fill: "#d00000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.949c978ed9a88d6f6b669719b6ca87e8.svg";
export { ForwardRef as ReactComponent };